import React, { Component } from 'react';

// Error boundary used to isolate the active-banner widget from the rest of the
// header. React 16+ error boundaries catch errors thrown during rendering,
// lifecycle methods, and constructors of the entire tree below them.
// If anything in <Banner /> ever throws, we silently render nothing instead
// of surfacing a broken UI.
export class BannerBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        try {
            console.warn('BannerBoundary: suppressed banner error', error, info);
        } catch (e) {
            // ignore
        }
    }

    render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children || null;
    }
}

export default BannerBoundary;



// WEBPACK FOOTER //
// ./src/components/BannerBoundary.jsx